import client from './client';
import type { AppNotification } from '../types';

export interface NotificationsResponse {
  items: AppNotification[];
  unreadCount: number;
}

export interface InvitePreviewEvent {
  _id: string;
  name: string;
  description: string;
  status: 'active' | 'ended';
  createdAt: string;
  endedAt: string | null;
  creatorName: string;
  photoCount: number;
  albumCount: number;
  recentPhotoUrl: string | null;
}

export interface InvitePreviewResponse {
  event: InvitePreviewEvent;
}

export const notificationsApi = {
  list: () =>
    client.get<NotificationsResponse>('/notifications').then((r) => r.data),

  managerInvitePreview: (id: string) =>
    client
      .get<InvitePreviewResponse>(`/notifications/${id}/manager-invite/preview`)
      .then((r) => r.data),

  markRead: (id: string) =>
    client.post<{ ok: true }>(`/notifications/${id}/read`).then((r) => r.data),

  markAllRead: () =>
    client.post<{ ok: true }>('/notifications/read-all').then((r) => r.data),

  acceptManagerInvite: (id: string) =>
    client
      .post<{ ok: true; alreadyActioned?: boolean }>(`/notifications/${id}/manager-invite/accept`)
      .then((r) => r.data),

  declineManagerInvite: (id: string) =>
    client
      .post<{ ok: true; alreadyActioned?: boolean }>(`/notifications/${id}/manager-invite/decline`)
      .then((r) => r.data),
};
